import React, { Component } from "react";
import UserAccountForm from "../../components/UserAccountForm";
import LoadingIndicator from "../../components/LoadingIndicator";
import { connect } from "react-redux";
import { navigate } from "../../store/navigation/operations";
import { loggedInUserGuid } from "../../store/iam/selectors";
import { fetchUser, updateUser } from "../../store/users/operations";
import { getUserWithId, isUpdatingUser } from "../../store/users/selectors";
import validators from "./validators";

class UserDetailsForm extends Component {
  state = {
    isDrawerOpen: false
  };

  componentDidMount() {
    this.props.fetchUser(this.props.myGuid);
  }

  updateUserProfile = user_details => {
    this.props.updateUser(this.props.myGuid, user_details);
  };

  render() {
    return (
      <div className="wide-content">
        {this.props.my_profile && (
          <UserAccountForm
            profile={this.props.my_profile}
            validators={validators}
            onUpdate={this.updateUserProfile}
            isLoading={this.props.isLoading}
            goToPublicProfile={_ => this.props.navigate(`/public-profile/${this.props.myGuid}`)}
          />
        )}
        {!this.props.my_profile && <LoadingIndicator />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  myGuid: loggedInUserGuid(state),
  my_profile: getUserWithId(state, loggedInUserGuid(state)),
  isLoading: isUpdatingUser(state, loggedInUserGuid(state))
});
const mapDispatchToProps = dispatch => ({
  navigate: to => dispatch(navigate(to)),
  fetchUser: id => dispatch(fetchUser(id)),
  updateUser: (id, user_details) => dispatch(updateUser(id, user_details))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDetailsForm);
